import API from '@/API/API'
import AccountSessionUtils from "./AccountSessionUtils";

const CreateListingStore = {
  api: API,
  accountUtils: AccountSessionUtils,
  state: {
    currentUserId: '',
    selectedService:null,
    services: [],
    fields: [],
    form: {},
    price:'',
    cityStates:[],
    city:'',
    state:'',
    threeMonthTrial:'N',
    listingId:0,
    prices:[],
    additionalStatePrices:[],
    calculatedPrice:"",
    hasValidCoupon:false,
    couponName:'',
    hometownCity:'',
    hometownState:'',
    screen: 'Service',
    photo:null,
    user:null,
    loading:false,
    background:{hex:'#f2f2f2'},
    textColor:{hex:'#000000'}
  },
  reset: function() {
    this.state = {
      currentUserId: '',
      selectedService:null,
      services: [],
      fields: [],
      form: {},
      price:'',
      cityStates:[],
      city:'',
      state:'',
      threeMonthTrial:'N',
      listingId:0,
      prices:[],
      additionalStatePrices:[],
      calculatedPrice:"",
      hasValidCoupon:false,
      couponName:'',
      screen: 'Service',
      photo:null,
      user:null,
      loading:false,
      background:{hex:'#f2f2f2'},
      textColor:{hex:'#000000'}
    }
  },
  getThreeMonthTrial: function(){
    let self = this;
    this.api
    .getThreeMonthTrial()
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (!data.error) {
            if(data.maintenanceMode){
              return
            }
            self.state.threeMonthTrial = data.threeMonthTrial
        }
      }else{
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getServices: function(success,error,maintenance){
    let self = this;
    this.api
    .getServices(true)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.services = data.services;
            success(self.state.services)
        }
      }else{
          error("Failed to get services");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getFields: function(success,error,maintenance){
    this.state.fields = []
    this.state.form = {}
    let self = this;
    this.api
    .getFields(this.state.selectedService.id)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.fields = data.fields;
            self.state.fields = self.state.fields.filter(it => {
              return it.active == 1;
            });
            self.state.fields.forEach(field => {
              if(field.type == 'Multi Select Dropdown'){
                self.state.form[field.id] = [];
              } else if (field.type == 'Email' && self.state.user) {
                self.state.form[field.id] = self.state.user.email || ''
              }else{
                self.state.form[field.id] = '';
              }
            });
            success(self.state.fields)
        }
      }else{
          error("Failed to get fields");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  validate: function(){
    var err = null
    this.state.fields.forEach(field => {
      if(field.required == 1){
        let value = this.state.form[field.id]
        if(value == '' || !value){
          err = field.name + ' is a required field';
          return;
        }
      }

      if(field.characterLimit > 0) {
        let value = this.state.form[field.id];
        if(value.length > field.characterLimit) {
          err = `${field.name} must be less than ${field.characterLimit} characters`
          return;
        }
      }
    });

    if(this.state.price == '') {
      err = "You must select a price"
      return err
    }

    if(this.state.cityStates.length < 1 && err == null && this.state.selectedService.noStates == 0){
      err = 'you must enter at least one state'
      return err;
    }

    if(this.state.hometownCity == '') {
      err = 'City is a required field'
      return err;
    }

    if(this.state.hometownState == '') {
      err = 'State is a required field'
      return err;
    }

    if(this.state.selectedService.id <= 0) {
      err = 'You must select a service'
      return err;
    }

    return err;
  },
  saveListing:function(success,error,maintenance){
    
    let err = this.validate();
    if(err){
      error(err)
      return;
    }
    this.state.loading = true
    let self = this;
    this.api
    .saveListing(
      this.state.selectedService.id,
      this.state.currentUserId,
      this.state.calculatedPrice,
      this.findPrice(),
      this.state.form,
      this.state.cityStates,
      this.state.hasValidCoupon ? 1 : 0,
      this.state.couponName,
      this.state.hometownCity,
      this.state.hometownState,
      this.state.photo,
      this.state.background.hex,
      this.state.textColor.hex
      )
    .then(function (res) {
      self.state.loading = false
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            success(res.data)
            self.state.listingId = res.data.listingId
            self.state.selectedService = {}
            self.state.form = {}
            self.state.fields = []
            self.state.cityStates = []
        }
      }else{
          error("Failed to save listing");
      }
    })
    .catch(e => {
      this.state.loading = false
      error('An Error Occurred')
    })
  },
  getPrices:function(success,error,maintenance){
    let self = this;
    this.api
    .getPrices()
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }

            self.state.prices = [{
              name:'Small',
              price:data.smallPrice
            },
            {
              name:'Medium',
              price:data.mediumPrice
            },
            {
              name:'Large',
              price:data.largePrice
            }]

            self.state.additionalStatePrices = [{
              name:'Small',
              price:data.smallAdditionalPrice
            },
            {
              name:'Medium',
              price:data.mediumAdditionalPrice
            },
            {
              name:'Large',
              price:data.largeAdditionalPrice
            }]

            success(res.data)
        }
      }else{
          error("Failed to save listing");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  findPrice() {

    var key = '';

    let result = this.state.prices.find(it => {
      return it.price == this.state.price
    });

    if(result) {
      key = result.name
    }

    return key
  },

  calculatePrice() {
    let price = this.state.price

    if(this.state.hasValidCoupon){
      this.state.calculatedPrice = '0.00'
      return
    }

    if(this.state.cityStates.length > 1 && this.state.selectedService.id != 1){
      
      let priceObj = this.state.prices.find(it => {
        return it.price == this.state.price
      });

      let name = priceObj.name
      let additionalStatePriceObj = this.state.additionalStatePrices.find(it => {
        return it.name == name
      });
      let additionalStatePrice = additionalStatePriceObj.price
      let additionalPrice = (this.state.cityStates.length - 1) * additionalStatePrice
      this.state.calculatedPrice = (parseFloat(price) + parseFloat(additionalPrice)).toFixed(2)
    }else{
      this.state.calculatedPrice = price
    }
  },
  validateCoupon(success,error,maintenance) {
    let self = this;
    this.api
    .validateCoupon(this.state.couponName)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (!data.error) {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            let status = data.status
            switch(status){
              case 'Not Found':
                error('Coupon Not Valid')
                break;
              case 'Disabled':
                error('Coupon Disabled')
                break;
              case "Enabled":
                self.state.hasValidCoupon = true
                success()
                break;
            }
        }
      }else{
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getUser: function(){
    let self = this;
    this.accountUtils.getUserId(data => {
      self.api
      .getUser(data.userId)
      .then(function (res) {
        self.state.loadedFavorites = true
        if (res.data) {
          let data = res.data
          if (!data.error) {
            self.state.user = data.user
          }
        }
      })
      .catch(e => { })
    },() => {})

  },
}

export default CreateListingStore



// WEBPACK FOOTER //
// ./src/components/account/CreateListingStore.js